import { useState, useEffect, useContext, useCallback, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { IconButton, Button, Backdrop, CircularProgress } from "@mui/material";
import axios from "axios";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Tooltip from "@mui/material/Tooltip";
import { DataGrid, jaJP } from "@mui/x-data-grid";
import { API, CSV_EXPCOUNT, PAGE_SIZE, MSG } from "./constantsFront";
import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import _ from 'lodash';
import { MsgContext } from "../../App";
//import { AuthInfoContext } from "./AuthContextProvider.tsx";
import { CSVLink } from "react-csv";
import { useDropzone } from "react-dropzone";
import CSVReader from 'react-csv-reader'
import { useRef } from "react";

/**
 * 輸出相手国一覧
 * @returns 
 */
function G0191ExportCountryList() {
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [ECRows, setECRows] = useState([]); // 輸出相手国
  const [SCRows, setSCRows] = useState([]); // 国同類
  const [Area, SetArea] = useState([]); // 地域
  const [dummyId, setDummyId] = useState(0);
  const [selectCountryCode, setSelectCountryCode] = useState(""); // 選択国コード
  const [deleteId, setDeleteId] = useState([]); // 削除ID

  const { msg, setMsg } = useContext(MsgContext);// エラーメッセージ
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(); // 選択したファイル
  const [fileData, setFileData] = useState(); // 選択したファイルデータ
  const [csvErrorMsg, setCsvErrorMsg] = useState([]); // CSVアップロードエラーメッセージ

  const [isLoading, setIsLoading] = useState(false);  // Loading

  const navigate = useNavigate();

  let body = { authKey: API.API_KEY };
  var kanaArr = {
    "ア行": 'アイウエオ',
    "カ行": 'カキクケコガギグゲゴ',
    "サ行": 'サシスセソザジズゼゾ',
    "タ行": 'タチツテトダヂヅデド',
    "ナ行": 'ナニヌネノ',
    "ハ行": 'ハヒフヘホパピプペポバビブベボ',
    "マ行": 'マミムメモ',
    "ヤ行": 'ヤユヨ',
    "ラ行": 'ラリルレロ',
    "ワ行": 'ワヲン',
  };

  // var kanaArr = {
  //   "アイウエオ" : 'ア行',
  //   "カキクケコガギグゲゴ" : 'カ行',
  //   "サシスセソザジズゼゾ" : 'サ行',
  //   "タチツテトダヂヅデド" : 'タ行',
  //   "ナニヌネノ" : 'ナ行',
  //   "ハヒフヘホパピプペポバビブベボ" : 'ハ行',
  //   "マミムメモ" : 'マ行',
  //   "ヤユヨ" : 'ヤ行',
  //   "ラリルレロ" : 'ラ行',
  //   "ワヲン" : 'ワ行',
  // };

  // CSVヘッダ
  const csvHeader = [
    { label: "国名", key: "country_name" },
    { label: "カナ名", key: "country_kana" },
    { label: "英語名", key: "country_name_en" },
    { label: "国コード", key: "country_code" },
    { label: "国名コード3", key: "country_name3" },
    { label: "国名コード2", key: "country_name2" },
    { label: "地域名", key: "area_name" },
    { label: "各行政区分", key: "iso" },
  ];

  // useEffect初回読込フラグ
  const refIsFirst = useRef(true);

  useEffect(() => {
    // 初回読込チェック
    if (!refIsFirst.current) {
      return;
    }

    displayData();

    // 地域マスタ取得
    axios.post("/m_area/select/auth", body).then(res => {
      // 取得チェック
      if (res.status != 200) {
        return;
      }

      SetArea(res.data.dataList);
    });

    // 初回読込フラグをfalseにセット
    refIsFirst.current = false;
  }, [])

  // 表示データ用
  function displayData() {
    // Loading
    setIsLoading(true);
    // 輸出相手国一覧取得
    axios.post("/m_export_country/select/auth", body).then(res => {
      // 取得チェック
      if (res.status != 200) {
        return;
      }

      let ECList = res.data.dataList;
      let rowsData = [];
      for (let i in ECList) {
        rowsData.push({
          id: i
          , country_code: ECList[i].country_code
          , country_name: ECList[i].country_name
          , country_kana: ECList[i].country_kana
          , country_name_en: ECList[i].country_name_en
          , country_name3: ECList[i].country_name3
          , country_name2: ECList[i].country_name2
          , area_code: ECList[i].area_code
          , area_name: ECList[i].area_name
          , iso: ECList[i].iso
        });
      }
      setECRows(rowsData);
    }).catch(error => {
      console.log('error:', error);
      setMsg(MSG.EXCEPTION);
    }).finally(() => {
      // Loading
      setIsLoading(false);
    });
  }

  // ヘッダー
  const ECColumns = [
    { field: "country_code", headerName: "国コード", width: 100 },
    { field: "country_name", headerName: "国名", width: 300 },
    { field: "country_name_en", headerName: "英語名", width: 300 },
    // { field: "country_name3", headerName: "国名コード3", width: 150 },
    // { field: "country_name2", headerName: "国名コード2", width: 150 },
    // { field: "area_code", headerName: "地域コード", width: 150 },
    {
      field: "edit", headerName: "", sortable: false, disableClickEventBubbling: true, width: 50,
      renderCell: (params) =>
        <Link to={"/G0192ExportCountryEdit"} state={{ countryCode: params.row.country_code }}>
          <Tooltip title="編集" arrow>
            <IconButton >
              <EditIcon />
            </IconButton>
          </Tooltip>
        </Link>
    },
    {
      field: 'delete', headerName: '', sortable: false, disableClickEventBubbling: true, width: 50,
      renderCell: (params) =>
        <Tooltip style={{ display: params.row.displayNA }} title="削除" arrow>
          <IconButton
            onClick={() => deleteEC(
              params.row.country_code
            )}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
    },
    {
      field: "synonym", headerName: "", sortable: false, disableClickEventBubbling: true, width: 100,
      renderCell: (params) => <Button onClick={() => handleClickOpen(params.row.country_code)}>同類</Button>
    },
  ];

  const SCColumns = [
    { field: "country_code", headerName: "国コード", width: 200 },
    { field: "country_name", headerName: "国名", width: 300, editable: true },
    { field: "country_kana", headerName: "カナ名", width: 300, editable: true },
    {
      field: "delete", headerName: "", sortable: false, disableClickEventBubbling: true, width: 100,
      renderCell: (params) =>
        <Tooltip title="削除" arrow>
          <IconButton onClick={() => deleteSC(params.id)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
    },
  ];

  // ダイアログ表示
  async function handleClickOpen(countryCode) {
    try {
      setDialogOpen(true);
      // 国同類一覧取得
      if (!countryCode) {
        throw "";
      }
      setSelectCountryCode(countryCode);
      body.countryCode = countryCode;
      body.isMaster = 0;
      body.order = "DESC";
      const res = await axios.post("/m_synonym_country/select/auth", body);
      // 取得チェック
      if (res.status != 200) {
        return;
      }

      let SCList = res.data.dataList;
      let rowsData = [];
      let dummyId;
      for (let i in SCList) {
        rowsData.push({
          id: i
          , country_code: countryCode
          , country_name: SCList[i].country_name
          , country_kana: SCList[i].country_kana
        });
        dummyId = i;
      }
      setSCRows(rowsData);
      setDummyId(dummyId);
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  };

  // 決定ボタン
  async function decisionButton() {
    try {
      let uniqueList = [];
      if (window.confirm("保存してもよろしいですか？")) {
        for (let i in SCRows) {
          console.log(SCRows[i])
          if (!(SCRows[i].country_name && SCRows[i].country_kana)) {
            return setMsg("未入力の項目が存在します。");
          }

          // 同じデータが存在する場合
          let unique = SCRows[i].country_name.trim()
          if (uniqueList.indexOf(unique) != -1) {
            return setMsg("名称が重複しています:"+unique);
          }
          uniqueList.push(unique);
        }

        const res = await axios.post("/m_synonym_country/max_synonym_id/auth", body);
        // 取得チェック
        if (res.status != 200) {
          return;
        }
        let synonymId = 0;
        if (res.data.dataList.length != 0) {
          synonymId = Number(res.data.dataList[0].synonym_id) + 1;
        }

        let arrStr = JSON.stringify(SCRows);
        // 検索
        body.arrStr = arrStr;
        body.synonymId = synonymId;
        body.countryCode = selectCountryCode;

        const res2 = await axios.post("/m_synonym_country/replacement/auth", body);
        // 取得チェック
        if (res2.status != 200) {
          return;
        }

        setDialogOpen(false);
        setSCRows([]);
      }
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  };

  // キャンセルボタン
  function cancelButton() {
    if (window.confirm("修正内容をキャンセルします。宜しいですか？")) {
      setDialogOpen(false);
      setSCRows([]);
    }
  };

  // 空追加
  function setEmpty() {
    // 配列の最後を取得するようにする
    let id = 0;
    if (typeof dummyId !== "undefined") {
      id = Number(dummyId) + 1;
    }
    setSCRows([{ id: id, country_code: selectCountryCode, country_name: null, country_kana: null }, ...SCRows]);
    setDummyId(id);
  }

  // 変更時
  function editChange(v) {
    // 変更した後に削除した配列をフィルタ
    let arr = Object.keys(v);
    if (arr.length != 0) {
      let cloneRows = _.cloneDeep(SCRows);
      let id = Number(arr[0]);
      let key = Object.keys(v[id]);
      let value = v[id][key].value;

      let idx = SCRows.findIndex(d => d.id == id);
      cloneRows[idx][key] = value;
      setSCRows(cloneRows);
    }
  }

  // 削除（輸出相手国）
  async function deleteEC(select_country_code) {
    try {
      if (window.confirm('削除してもよろしいですか？')) {
        console.log('削除処理開始');
        body.SelectCountryCode = select_country_code;
        const res = await axios.post("/m_export_country/delete/auth", body);
        // 取得チェック
        if (res.status != 200) {
          return;
        }
        return displayData();
      }
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。1");
    }
  }

  // 削除（同類）
  function deleteSC(id) {
    let cloneRows = _.cloneDeep(SCRows);
    for (let i in cloneRows) {
      if (cloneRows[i].id == id) {
        setDeleteId([...deleteId, String(id)]);
        cloneRows.splice(i, 1);
        return setSCRows(cloneRows);
      }
    }
  }

  // CSVファイルを選択時trueを設定
  const changeHandlerCsv = (event) => {
    setSelectedFile(event.target.files[0]);
    event.target.value = '';
  };

  // ファイル選択ボタン
  const onDrop = useCallback((acceptedFiles) => {
    setSelectedFile(acceptedFiles[0]);
  }, []);
  const { open, acceptedFiles } = useDropzone({
    accept: {
      'text/csv': [],
    },
    multiple: false,
    onDrop,
    noClick: true
  });
  const files = useMemo(() =>
    acceptedFiles.map((file) => (
      <li style={{ listStyleType: "none" }} key={file.path}>
        {file.path}
      </li>
    )
    ), [acceptedFiles]);

  // CSVアップロードボタン
  async function handleFiles() {
    try {
      // Loading
      setIsLoading(true);
      // 再レンダリング用スリープ  
      await new Promise(r => setTimeout(r, 100));

      setFileData();
      setSelectedFile();
      setCsvErrorMsg([]);
      if (!selectedFile) {
        return setMsg("ファイルを選択してください");
      }

      let uniqueList = [];
      let csletr = [];

      // 1行ごとに処理
      for (let i in fileData) {
        let cells = fileData[i];

        //現在の行数
        let row = Number(i) + 1;

        // 必須チェックエラーカウント
        var csvError = 0;

        // エリア存在チェックカウント
        var areaCnt = 0;

        // 五十音
        var kanaTmpData = '';

        //CSVの中身が正しい場合
        if (cells.length == 8) {

          uniqueList.push(cells[0]);
          csletr.push(cells);

          // 必須チェック開始
          if (csletr[i][CSV_EXPCOUNT.NAME] == '') {
            csvError++;
            csvErrorMsg.push(row + "行目 : 国名は必須です。");
          }

          if (csletr[i][CSV_EXPCOUNT.KANA] == '') {
            csvError++;
            csvErrorMsg.push(row + "行目 : カナ名は必須です。");
          }

          if (csletr[i][CSV_EXPCOUNT.EN] == '') {
            csvError++;
            csvErrorMsg.push(row + "行目 : 英語名は必須です。");
          }

          if (csletr[i][CSV_EXPCOUNT.CODE] == '') {
            csvError++;
            csvErrorMsg.push(row + "行目 : 国コードは必須です。");
          }

          // if (csletr[i][CSV_EXPCOUNT.NAME3] == '') {
          //   csvError++;
          //   csvErrorMsg.push(row + "行目 : 国名コード3は必須です。");
          // }

          // if (csletr[i][CSV_EXPCOUNT.NAME2] == '') {
          //   csvError++;
          //   csvErrorMsg.push(row + "行目 : 国名コード2は必須です。");
          // }

          if (csletr[i][CSV_EXPCOUNT.AREA_NAME] == '') {
            csvError++;
            csvErrorMsg.push(row + "行目 : 地域名は必須です。");
          }

          // if (csletr[i][CSV_EXPCOUNT.ISO] == '') {
          //   csvError++;
          //   csvErrorMsg.push(row + "行目 : 各行政区分は必須です。");
          // }

          if (csvError > 0) {
            return setMsg(csvErrorMsg.join('<br />'));
          }

          // 必須チェック終了

          // 地域マスタから地域コードを取得する
          if (i != 0) {
            for (let j in Area) {
              if (csletr[i][CSV_EXPCOUNT.AREA_NAME] == Area[j].area_name) {
                csletr[i][CSV_EXPCOUNT.AREA_NAME] = Area[j].area_code;
                areaCnt++;
                break;
              }
            }

            if (areaCnt == 0) {
              console.log(csletr[i][CSV_EXPCOUNT.AREA_NAME]);
              return setMsg(row + "行目 : 地域名が未登録です。");
            }

            // 五十音
            kanaTmpData = cngFirstLetter(csletr[i][CSV_EXPCOUNT.KANA].slice(0, 1));
            csletr[i][CSV_EXPCOUNT.JA_INIT] = kanaTmpData;
          }

        } else {
          return setMsg("項目の数が正しくありません。");
        }
      }

      console.log("CSVのチェックが終わりました。");

      const maxid = await axios.post("/m_synonym_country/max_synonym_id/auth", body);
      // 取得チェック
      if (maxid.status != 200) {
        return;
      }

      // 同類IDの最大値を取得
      let synonymId = 0;
      if (maxid.data.dataList.length != 0) {
        synonymId = Number(maxid.data.dataList[0].synonym_id) + 1;
      }

      let arrStr = JSON.stringify(csletr);
      body.arrStr = arrStr

      body.synonymId = synonymId;

      const res1 = await axios.post("/m_export_country/upload/auth", body);
      // 輸出相手国マスタ
      // const res2 = await axios.post("/m_synonym_country/upload/admin", body); // 国同類マスタ
      if (res1.status === 200) {
        displayData();
        alert("アップロードに成功しました。");
        // setMsg("アップロードに成功しました。");
      }
    } catch (err) {
      setMsg("登録に失敗しました。");
      return;
    } finally {
      setIsLoading(false);
    }
  }

  // カナ名から五十音を取得する
  function cngFirstLetter(kanaData) {
    var reKey = "";
    var key = Object.keys(kanaArr); // 例：ア行
    var data = Object.values(kanaArr); // 例：アイウエオ

    for (let i in data) {
      if (data[i].indexOf(kanaData) >= 0) {
        reKey = key[i];
      }
    }

    return reKey;
  }

  return (
    <>
      <div class="mainLinkMenu"></div>
      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">

              <Container maxWidth="lg" id="container">
                {/* Loading */}
                <Backdrop open={isLoading}
                  sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                  <CircularProgress />
                </Backdrop>
                <Stack spacing={2}>

                  <h1>輸出相手国一覧</h1>

                  <Stack spacing={2} direction="row">
                    <Button component={Link} to={"/G0192ExportCountryEdit"}
                      state={{ countryCode: -1 }}
                      style={{ width: "200px", color: "white", textDecoration: "none" }}>
                      新規追加
                    </Button>

                    <CSVLink style={{ color: "white", textDecoration: "none" }}
                      filename={"輸出相手国.csv"} headers={csvHeader} data={ECRows}>
                      <Button
                        style={{ width: "200px" }}>CSVダウンロード
                      </Button>
                    </CSVLink>
                  </Stack>
                  <Stack spacing={2} direction="row">

                    <Button style={{ width: "200px" }} letiant="contained" component="label" onChange={changeHandlerCsv}>
                      CSVファイルを選択
                      <CSVReader
                        inputStyle={{ display: "none" }}
                        onFileLoaded={(data, fileInfo, originalFile) => setFileData(data)}
                      />
                    </Button>

                    {selectedFile != null ? (
                      <>
                        <div>
                          <p>ファイル名: {selectedFile.name}</p>
                        </div>
                        <Button
                          style={{ width: "200px" }}
                          onClick={handleFiles}
                        >
                          登録実行
                        </Button>
                      </>
                    ) : (
                      <div><p>CSVファイルが選択されていません</p></div>
                    )}
                  </Stack>

                  <div style={{ width: "100%" }}>
                    <DataGrid
                      className="DataGrid"
                      columns={ECColumns}
                      rows={ECRows}
                      autoHeight
                      disableSelectionOnClick
                      pageSize={pageSize}
                      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                      pagination
                      localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
                    />
                  </div>

                  <Dialog
                    fullWidth
                    maxWidth="xl"
                    open={dialogOpen}
                    onClose={cancelButton}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      国同類一覧
                    </DialogTitle>
                    <DialogContent style={{ height: "100%", minHeight: "300px" }}>

                      {/* <Button component={Link} to={"/G0182StaffEdit"} state={{ ID: -1 }} style={{ width: "200px" }}>輸出相手国新規登録</Button> */}
                      <Button style={{ width: "200px" }} onClick={setEmpty}>新規追加</Button>

                      <div style={{ width: "100%" }}>
                        <DataGrid
                          className="DataGrid"
                          columns={SCColumns}
                          rows={SCRows}
                          autoHeight
                          edit
                          onEditRowsModelChange={editChange}
                          disableSelectionOnClick
                          localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
                        />
                      </div>

                    </DialogContent>
                    <DialogActions>
                      <Button onClick={cancelButton}>キャンセル</Button>
                      <Button onClick={decisionButton}>保存</Button>
                    </DialogActions>
                  </Dialog>

                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>

  );
}

export default G0191ExportCountryList;